// extracted by mini-css-extract-plugin
export default {"search_section":"Setting_search_section__ge8bn","search_input":"Setting_search_input__ox-pL"};